export default (ref) => {
  if (!ref.mentionedIn) return;

  const mod = (n, modulo) => ((n % modulo) + modulo) % modulo;

  const teardown = ref.mentionedIn.map((bar) => {
    const marquee = bar.querySelector(".marquee") as HTMLElement;

    let itemWidth = 0;

    window.addEventListener("resize", getSize);

    // bar.addEventListener("pointerover", () => (speed = 0));
    // bar.addEventListener("pointerleave", () => (speed = 0.5));

    function getSize() {
      const { width } = marquee.firstElementChild.getBoundingClientRect();
      itemWidth = width;
    }

    getSize();

    let running = true;
    let progress = 0;
    let speed = parseFloat(bar.dataset.speed) || 0.5;

    // keeps the loop to 60fps
    const tick = (t1: number) => (t2: number) => {
      if (!running) return;

      if (t2 - t1 > 16.6) {
        requestAnimationFrame(tick(t2));

        progress -= speed;

        marquee.style.transform = `translateX(${
          -itemWidth + mod(progress, itemWidth)
        }px)`;
      } else {
        requestAnimationFrame(tick(t1));
      }
    };

    tick(0)(0);

    return () => {
      running = false;
    };
  });

  return () => {
    teardown.forEach(t => t())
  }
};
